module.exports = __webpack_public_path__ + "media/icons/player-c18e5c49.png";